import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form", "verificationForm", "verificationCode", "checkCodeBtn", 
                   "resultMessage", "numberToVerify", "resendCode"]

  connect() {
    this.formTarget.addEventListener("submit", this.handleSubmit.bind(this));
    
    this.modal = new bootstrap.Modal(document.getElementById("verificationModal"));
    
    const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
    closeButton.addEventListener('click', () => {
        this.modal.hide();
        this.handleModalClose();
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    const submitButton = event.target.querySelector('.js-submit-btn');
    submitButton.disabled = true;

    try {
      const response = await this.sendVerificationRequest('POST');
      if (response.ok) {
        this.modal.show();
      } else {
        submitButton.disabled = false;
      }
    } catch (error) {
      this.resultMessageTarget.style.color = "red";
      this.resultMessageTarget.textContent = "Failed to send verification code. Please try again later.";
      submitButton.disabled = false;
    }
  }

  verificationCodeInput(event) {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    const hasValue = event.target.value.length > 0;
    this.checkCodeBtnTarget.disabled = !hasValue;
  }

  setMessage(target, isSuccess, message) {
    target.style.color = isSuccess ? "green" : "red";
    target.textContent = message;
  }

  async verifyCode(event) {
    event.preventDefault();
    
    try {
      const response = await this.sendVerificationRequest('PUT', this.verificationCodeTarget.value);
      const data = await response.json();
      
      if (data.error) {
        this.setMessage(this.resultMessageTarget, false, data.error);
      } else {
        this.checkCodeBtnTarget.disabled = true;
        this.setMessage(this.resultMessageTarget, true, data.message);
        this.formTarget.submit();
      }
    } catch (error) {
      console.error("Verification failed:", error);
    }
  }

  async resendCode(event) {
    event.preventDefault();
    
    try {
      const response = await this.sendVerificationRequest('POST');
      if (response.ok) {
        this.setMessage(this.resendCodeTarget, true, "Code sent again");
      } else {
        this.setMessage(this.resendCodeTarget, false, "Error. Please try again later");
      }
    } catch (error) {
      console.error("Failed to resend code:", error);
    }
  }

  async sendVerificationRequest(method, verificationCode = null) {
    const phone = this.numberToVerifyTarget.textContent.trim();
    const body = {
      profile: {
        phone: phone,
        validation: "false",
        update_profile: "false"
      }
    };

    if (verificationCode) {
      body.profile.verification_code = verificationCode;
    }

    return fetch(this.verificationFormTarget.action, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify(body)
    });
  }

  handleModalClose() {
    this.formTarget.querySelector('.js-submit-btn').disabled = false;
    if (this.hasResultMessageTarget) {
        this.resultMessageTarget.textContent = '';
    }
  }
} 